import Picker, { PickerValue } from 'react-mobile-picker'
import { useState, useEffect } from 'react'
import Button from 'components/Button'
import './index.scss'

interface InputTimeProps {
  value: string
  onChange: (date: string) => void
  label: string
  error?: string
}

const PickerItemChild: React.FC<{ selected: boolean, value: string }> = ({ selected, value }) => {
  return (
    <div
      style={{
        fontWeight: selected ? 'bold' : 'normal',
        color: selected ? '#000' : '#888'
      }}>
      {value}
    </div>
  )
}

const InputTime: React.FC<InputTimeProps> = ({ value, label, error, onChange }) => {
  const [isOpen, setIsOpen] = useState(false)
  const [pickerValue, setPickerValue] = useState<PickerValue>(() => {
    const date = new Date()
    const [hour, minute] = value ? value.split(':') : [`${date.getHours()}`, String(date.getMinutes()).padStart(2, '0')]
    return { hour, minute }
  })

  const handleConfirm = () => {
    const newDate = `${pickerValue.hour}:${pickerValue.minute}`
    onChange(newDate)
    setIsOpen(false)
  }

  useEffect(() => {
    if (isOpen) {
      document.body.style.setProperty('overflow', 'hidden')
      return () => {
        document.body.style.removeProperty('overflow')
      }
    }
  }, [isOpen])


  return (
    <>
      <div
        className={`myInput myDateInput ${error ? 'error' : ''}`}
        onClick={() => {
          setIsOpen(true)
        }}>
        <label>{error ? error : label}</label>
        <div>
          {value
            ? <span>{pickerValue.hour}:{pickerValue.minute}</span>
            : <span style={{ color: 'rgba(41, 41, 41, 0.3)' }}>Kliknij, aby wybrać godzinę</span>}
          <i className='icon icon--time'></i>
        </div>
      </div>

      {isOpen && (
        <div className='dateModal'>
          <div className='dateModal__content'>
            <div className='title'>
              <i className='icon icon--time'></i>
              <h1>Wybierz godzinę</h1>
            </div>

            <div className='head'>
              <span>Godzina</span>
              <span>Minuta</span>
            </div>

            <Picker
              wheelMode='natural'
              value={pickerValue}
              onChange={(newValue) => {
                setPickerValue(newValue)
              }}>

              <Picker.Column name='hour'>
                {Array.from({ length: 24 }, (_, i) => String(i)).map((hour) => (
                  <Picker.Item
                    key={hour}
                    value={hour}>
                    {({ selected }) => <PickerItemChild
                      value={hour}
                      selected={selected}
                    />}
                  </Picker.Item>))}
              </Picker.Column>

              <Picker.Column name='minute'>
                {Array.from({ length: 60 }, (_, i) => String(i).padStart(2, '0')).map((minute) => (
                  <Picker.Item
                    key={minute}
                    value={minute}>
                    {({ selected }) => <PickerItemChild
                      value={minute}
                      selected={selected}
                    />}
                  </Picker.Item>))}
              </Picker.Column>
            </Picker>

            <Button type='primary' text='Gotowe' action={handleConfirm} />
          </div>
        </div>
      )}
    </>
  )
}

export default InputTime